import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the microsoftVerify state domain
 */

const selectMicrosoftVerifyDomain = state => state.microsoftVerify || initialState;

const makeSelectMicrosoftVerifyState = () =>
  createSelector(selectMicrosoftVerifyDomain, subState => subState);

/**
 * Other specific selectors
 */

const makeSelectIsVerify = () =>
  createSelector(selectMicrosoftVerifyDomain, subState => subState.isVerify);

const makeSelectError = () =>
  createSelector(selectMicrosoftVerifyDomain, subState => subState.error);

export { makeSelectIsVerify, makeSelectError };
